import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useCustomSnackbar } from '../../../../hooks/useCustomEnqueueSnackbar';
import { userInfoApi } from '../../../../services/apiServices/user/userInfo';
import {
  ButtonClassNames,
  GlobalRouteNames,
  AccountSettingRouteNames,
  SuccessRouteNames,
} from '../../../../models/Common';
import { CustomMUIButton } from '../../buttons/CustomMUIButton';
import { TextButton, TextButtonClassNames } from '../../buttons/TextButton';
import { AnimatedIcon } from '../../AnimatedIcon';
import WarningIconLight from '../../../../assets/images/lottieIcons/warning/warning.light.json';
import WarningIconDark from '../../../../assets/images/lottieIcons/warning/warning.dark.json';
import { getErrorMessage } from '../../../../utils';

interface IAcceptMembership {
  handleClose: () => void;
}

export const AcceptMembership: FC<IAcceptMembership> = ({ handleClose }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const [joinMember, { isLoading }] = userInfoApi.useJoinMemberAccountMutation();

  const handleContinue = async () => {
    try {
      await joinMember().unwrap();
      history.push(`${GlobalRouteNames.SuccessPublicPage}${SuccessRouteNames.MembershipConfirmed}`);
      handleClose();
    } catch (err) {
      const message = getErrorMessage(err);
      customEnqueueSnackbar(message, 'error');
    }
  };

  const handlePasswordChange = () => {
    history.push(`${GlobalRouteNames.AccountSettingPage}${AccountSettingRouteNames.PasswordPage}`);
    handleClose();
  };

  return (
    <div className="modals">
      <div className="modals__header modals__header__top-up">
        <AnimatedIcon lightIcon={WarningIconLight} darkIcon={WarningIconDark} className="icon-warning" />
        <article className="modals__header__title">{t('multiAccount.acceptMembership')}</article>
        <p className="modals__header__prompt">
          {t('multiAccount.notAgreeLinking')}
          <TextButton
            label={t('multiAccount.changingPassword')}
            handleClick={handlePasswordChange}
            className={TextButtonClassNames.PrimaryActive}
          />
          .
        </p>
      </div>
      <div className="modals__btn-group">
        <CustomMUIButton
          label={t('multiAccount.cancel')}
          handleClick={handleClose}
          className={ButtonClassNames.SecondaryOutlined}
          isBold
        />
        <CustomMUIButton
          label={t('buttons.join')}
          handleClick={handleContinue}
          className={ButtonClassNames.PrimaryFulfilled}
          isLoading={isLoading}
          isBold
        />
      </div>
    </div>
  );
};
